import type { RouteRecordRaw } from "vue-router";


export const AuthRoutes: RouteRecordRaw[] = [
    {
        path: 'login',
        name: 'auth',
        component: () => import('./components/AuthLogin.vue')
    },
    {
        path: 'recover',
        name: 'recover',
        component: () => import('./components/AuthRecover.vue')
    },
    {
        path: 'first-access/:token',
        name: 'firstAcess',
        component: () => import('./components/AuthFirstAccess.vue')
    },
]